module.exports = __webpack_public_path__ + "img/male.ba5f6d69.svg";